import { render, staticRenderFns } from "./PortalLoading.vue?vue&type=template&id=38c86b6a&"
import script from "./PortalLoading.vue?vue&type=script&lang=js&"
export * from "./PortalLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports